import React from 'react';
import { CircularProgress } from '@mui/material';
import * as SC from './Spinner.sc';

export const Spinner = () => {
  return (
    <SC.Container>
      <CircularProgress />
    </SC.Container>
  );
};
